// removed by extract-text-webpack-plugin
module.exports = {"search_form":"_23nx1OZnpyb4q_oNrMwW_F"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchForm/styles.css
// module id = 702
// module chunks = 0